import React from 'react';

import classNames from '../utils/classNames';

import type { ReactElement } from 'react';

interface ContainerProps<T extends React.ElementType> {
  as?: T;
  className?: string;
  children: React.ReactNode;
}

const Container = <T extends React.ElementType = 'div'>({
  as,
  className = '',
  children,
}: Omit<React.ComponentPropsWithoutRef<T>, keyof ContainerProps<T>> &
  ContainerProps<T>): ReactElement => {
  const Component = as ?? 'div';

  return (
    <Component className={classNames('mx-auto max-w-7xl px-6 lg:px-8', className)}>
      <div className="mx-auto max-w-2xl lg:max-w-none">{children}</div>
    </Component>
  );
};

Container.defaultProps = {
  as: undefined,
  className: '',
};

export default Container;
